import React from 'react';

// Auth components
import { LoginForm } from '../components/auth/LoginForm';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';
import { ResetPasswordForm } from '../components/auth/ResetPasswordForm';
import { MFAVerification } from '../components/auth/MFAVerification';
import { MFAEnrollment } from '../components/auth/MFAEnrollment';
import MFARecovery from '../pages/MFARecovery';
import { VerifyEmail } from '../pages/VerifyEmail';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

export const authRoutes: RouteConfig[] = [
  {
    path: "/login",
    element: <LoginForm />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordForm />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordForm />,
  },
  {
    path: "/mfa-verify",
    element: <MFAVerification />,
  },
  {
    path: "/mfa-recovery",
    element: <MFARecovery />,
  },
  {
    path: "/mfa-setup",
    element: <MFAEnrollment />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
];
